import {DialogAction} from "../common/dialog.actions";
import {ActionEnum} from "../action.enum";
import {BaseActionClassModel} from "../base-action-class.model";
import {CompoTreeType} from "../../enums/CompoTreeType";
import {ParentSelectedChildModel} from "../../models/global/parentSelectedChild.model";
import {
  OrganizationOrLocationNodeModel
} from "../../models/organization-location/organization-or-location-node.model";
import {ComponentClassWithChildrenCountDto} from "../../models/component_class/ComponentClassWithChildrenCountDto";
import {
  OrgLocationClassObjectSelectionMode
} from "../../content/components/org-location-class-object-selection-dialog/org-location-class-object-selection.enum";

export namespace OrgLocationClassObjectSelectDialogActions {

  //region DIALOG
  export enum Step {
    SELECT_MODE = 'ELECT_MODE',
    ORG_LOCATION = "ORG_LOCATION",
    CLASS = "CLASS",
    OBJECT = "OBJECT",
  }

  export class OpenDialog {
    static readonly type: ActionEnum = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_OPEN_DIALOG;

    constructor(
      public organizationId: string,
      public predefinedSelectionMode: OrgLocationClassObjectSelectionMode,
      public selectionModes: OrgLocationClassObjectSelectionMode[],
      public excludedObjectIds?: string[]
    ) {}
  }

  export class CloseDialog {
    static readonly type: ActionEnum = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_CLOSE_DIALOG;
  }

  export class SetSelectionMode {
    static readonly type: ActionEnum = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_SET_SELECTION_MODE;

    constructor(public selectionMode: OrgLocationClassObjectSelectionMode) {}
  }

  export class NextStep {
    static readonly type: ActionEnum = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_NEXT_STEP;
  }

  export class PreviousStep {
    static readonly type: ActionEnum = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_PREVIOUS_STEP;
  }

  export class CheckFetchObjects extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_CHECK_FETCH_OBJECTS;
  }
  //endregion

  //region ORG-LOCATION STEP
  export class SetOrgLocationYIndexFor extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_SET_ORG_LOCATION_Y_INDEX_FOR;

    constructor(public id: string, public type: CompoTreeType, public parentId: string, public index: number) {
      super(null);
    }
  }

  export class RemoveOrgLocationYIndexFor extends BaseActionClassModel {
    static readonly type = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_REMOVE_ORG_LOCATION_Y_INDEX_FOR;

    constructor(public id: string, public type: CompoTreeType) {
      super(null);
    }
  }
  //endregion

  //region CLASS STEP
  export class SetClassYIndexFor extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_SET_CLASS_Y_INDEX_FOR;

    constructor(public id: string, public parentId: string, public index: number) {
      super(null);
    }
  }

  export class RemoveClassYIndexFor extends BaseActionClassModel {
    static readonly type = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_REMOVE_CLASS_Y_INDEX_FOR;

    constructor(public id: string) {
      super(null);
    }
  }
  //endregion

  //region SELECTION
  export class SetOrgLocationSelection extends BaseActionClassModel {
    static readonly type = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_ORG_LOCATION_SELECTION;

    constructor(public organizationIds: Set<string>, public locationIds: Set<string>) {
      super(null);
    }
  }

  export class SetClassSelection extends BaseActionClassModel {
    static readonly type = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_CLASS_SELECTION;

    constructor(public classIds: Set<string>) {
      super(null);
    }
  }

  export class SetObjectSelection extends BaseActionClassModel {
    static readonly type = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_OBJECT_SELECTION;

    constructor(public objectIds: Set<string>) {
      super(null);
    }
  }

  export class SetAllOrganizationIds extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_SET_ALL_ORGANIZATION_IDS;

    constructor(public organizationIds: Set<string>) {
      super(null);
    }
  }

  export class SetAllLocationIds extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_SET_ALL_LOCATION_IDS;

    constructor(public locationIds: Set<string>) {
      super(null);
    }
  }

  export class SetAllClassIds extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_SET_ALL_CLASS_IDS;

    constructor(public classIds: Set<string>) {
      super(null);
    }
  }

  export class SetAllObjectIds extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_SET_ALL_OBJECT_IDS;

    constructor(public objectIds: Set<string>) {
      super(null);
    }
  }
  //endregion

  //region SAVE
  export class Save extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_SAVE;

    constructor() {
      super(null);
    }
  }

  export class DispatchSave extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_DISPATCH_SAVE;

    constructor(
      public organizationIds: Set<string>,
      public locationIds: Set<string>,
      public classIds: Set<string>,
      public objectIds: Set<string>
    ) {
      super(null);
    }
  }

  export class SaveSuccessful extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_SAVE_SUCCESSFUL;

    constructor() {
      super(null);
    }
  }

  export class SaveFailed extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_SAVE_FAILED;

    constructor() {
      super(null);
    }
  }
  //endregion

  //region RESET
  export class ResetState extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.ORG_LOCATION_CLASS_OBJECT_SELECT_DIALOG_RESET_STATE;

    constructor() {
      super(null);
    }
  }
  //endregion
}
